import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { MetricsClient, metricsApiRef } from './api';
import { rootRouteRef } from './routes';

export const metricsPlugin = createPlugin({
  id: 'metrics-dashboard',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: metricsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, fetchApi, identityApi }) =>
        new MetricsClient({ discoveryApi, fetchApi, identityApi }),
    }),
  ],
});

export const MetricsPage = metricsPlugin.provide(
  createRoutableExtension({
    name: 'MetricsPage',
    component: () =>
      import('./components/MetricsPage').then(m => m.MetricsPage),
    mountPoint: rootRouteRef,
  }),
);
